import { render, staticRenderFns } from "./EditShipping.vue?vue&type=template&id=088dd3d6"
import script from "./EditShipping.vue?vue&type=script&lang=js"
export * from "./EditShipping.vue?vue&type=script&lang=js"
import style0 from "./EditShipping.vue?vue&type=style&index=0&id=088dd3d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports